import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-information-technology',
  imports: [
    MatButtonModule,
    RouterModule
  ],
  templateUrl: './information-technology.component.html',
  styleUrl: './information-technology.component.css'
})
export class InformationTechnologyComponent {

}
